<template>
  <div id="app" class="page">
    <SpriteMap />
    <Header />
    <div class="page__content">
      <transition name="expand">
        <OrderProcess
          v-show="hasOrderProcess && isOrderProcessOngoing && isCheckoutOpen"
        ></OrderProcess>
      </transition>
      <transition name="fade">
        <router-view />
      </transition>
    </div>
    <Environment />
    <Footer />
    <Snackbar />
    <!--
    <SnackbarInfo />
    -->
    <CookieConsent />
    <b-modal v-model="welcomeJomatik" :full-screen="true">
      <welcome-jomatik />
    </b-modal>
  </div>
</template>

<style lang="scss">
@import "styles/_all.scss";
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
<script>
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import { mapGetters } from "vuex";
import { viewports } from "./store/constants/viewports";
import { orderProcess } from "./store/constants/order-process";

import OrderProcess from "./components/checkout/OrderProcess";
import SpriteMap from "./components/svg/SpriteMap";
import Snackbar from "./components/shared/Snackbar";
//import SnackbarInfo from "./components/shared/SnackbarInfo";
import CookieConsent from "./components/shared/CookieConsent";
import Environment from "./components/shared/Environment";
import { $axios } from "./store/modules/axios-instance";
import WelcomeJomatik from "./components/global/WelcomeJomatik";

export default {
  components: {
    WelcomeJomatik,
    CookieConsent,
    Snackbar,
    //SnackbarInfo,
    SpriteMap,
    OrderProcess,
    Footer,
    Header,
    Environment,
  },
  data() {
    return {
      // shows info modal describing the acquisition of jomatik by the murtfeldt-group
      welcomeJomatik: false,
      viewports,
    };
  },
  computed: {
    ...mapGetters([
      "currentViewport",
      "currentOrderProcessStep",
      "isCheckoutOpen",
    ]),
    hasOrderProcess() {
      switch (this.currentViewport) {
        case viewports.MOBILE.name:
        case viewports.TABLET.name:
          return true;
        default:
          return false;
      }
    },
    isOrderProcessOngoing() {
      return (
        this.currentOrderProcessStep !== orderProcess.STEPS.NO_ORDER_ONGOING &&
        this.currentOrderProcessStep !== orderProcess.STEPS.ORDER_COMPLETED
      );
    },
  },
  methods: {
    setScreenSize() {
      let screenSize = {
        width: window.innerWidth,
        height: window.innerHeight,
      };

      this.$store.dispatch("setScreenSize", screenSize);
    },
    attachEventListeners() {
      window.addEventListener("resize", this.setScreenSize);
    },
    removeEventListeners() {
      window.removeEventListener("resize", this.setScreenSize);
    },
  },
  created() {
    let locale = "de-DE";
    let header = "DE";
    switch (this.$route.params.lang) { // TODO: this.$route.params.lang seems to be
                                       // undefined and therefore it resolves to 'DE'
      case "en":
        locale = "en-US";
        header = "GB";
      case "fr":
        locale = "fr-FR";
        header = "FR";
    }
    this.$i18n.locale = locale;
    $axios.defaults.headers = {
      ...$axios.defaults.headers,
      "mas-language-key": header,
    };
    this.attachEventListeners();
  },
  mounted() {
    if (this.$route.hash === "#welcome-jomatik") {
      this.welcomeJomatik = true;
    }

    this.setScreenSize();
    this.$store.dispatch("createCart");
    this.$store.dispatch("checkAuth");
    this.$store.dispatch("fetchItemsFromLocalStorage");
    this.$store.dispatch("fetchShippingCountries");
    this.$store.dispatch("reloadDiscount");
  },
  destroyed() {
    this.removeEventListeners();
  },
};
</script>
